export default class SessionStorageService {
    constructor () {
        this.keys = []
    }

    setByKey (sessionKey, obj) {
        sessionStorage[sessionKey] = JSON.stringify(obj)
    }

    getByKey (key) {
        const stored = sessionStorage[key]
        if (!stored) {
            return
        }

        return JSON.parse(stored)
    }

    clearAll () {
        Object.keys(sessionStorage).forEach(function (storageKey) {
            delete sessionStorage[storageKey]
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/SessionStorageService.js